import React from 'react';

export const AOD9604Diagram: React.FC = () => {
  return (
    <svg viewBox="0 0 800 650" xmlns="http://www.w3.org/2000/svg" style={{ maxHeight: '550px', width: '100%' }}>
      {/* Title */}
      <text x="400" y="50" textAnchor="middle" fontSize="24" fontWeight="bold" fill="#333">
        AOD-9604: Mechanisms and Pathways
      </text>
      
      {/* Background */}
      <rect x="50" y="80" width="700" height="520" rx="10" fill="#f8f9fa" stroke="#ccc" strokeWidth="1" />
      
      {/* Cell Membrane */}
      <rect x="100" y="300" width="600" height="10" rx="5" fill="#e2e8f0" stroke="#94a3b8" strokeWidth="2" />
      <text x="120" y="290" fontSize="14" fill="#475569">Cell Membrane</text>
      
      {/* 1. Peptide Structure */}
      <rect x="100" y="120" width="160" height="80" rx="8" fill="#eef2ff" stroke="#818cf8" strokeWidth="2" />
      <text x="180" y="150" textAnchor="middle" fontSize="16" fontWeight="bold" fill="#4f46e5">AOD-9604</text>
      <text x="180" y="175" textAnchor="middle" fontSize="12" fill="#4f46e5">GH Fragment 176-191</text>
      
      {/* 2. Primary Mechanism */}
      <circle cx="270" cy="250" r="60" fill="#f0fdf4" stroke="#34d399" strokeWidth="2" />
      <text x="270" y="235" textAnchor="middle" fontSize="14" fontWeight="bold" fill="#047857">β3-Adrenergic</text>
      <text x="270" y="255" textAnchor="middle" fontSize="14" fontWeight="bold" fill="#047857">Receptor</text>
      <text x="270" y="275" textAnchor="middle" fontSize="12" fill="#047857">Stimulation</text>
      
      {/* Arrow 1 */}
      <line x1="190" y1="200" x2="230" y2="230" stroke="#94a3b8" strokeWidth="2" markerEnd="url(#arrowhead)" />
      
      {/* 3. Intracellular Cascade */}
      <rect x="220" y="350" width="120" height="60" rx="8" fill="#eff6ff" stroke="#60a5fa" strokeWidth="2" />
      <text x="280" y="375" textAnchor="middle" fontSize="14" fontWeight="bold" fill="#1d4ed8">cAMP</text>
      <text x="280" y="395" textAnchor="middle" fontSize="12" fill="#1d4ed8">Increases</text>
      
      {/* Arrow 2 */}
      <line x1="270" y1="310" x2="270" y2="350" stroke="#94a3b8" strokeWidth="2" markerEnd="url(#arrowhead)" />
      
      {/* 4. Effect on Lipid Metabolism */}
      <rect x="220" y="450" width="120" height="60" rx="8" fill="#fff7ed" stroke="#fb923c" strokeWidth="2" />
      <text x="280" y="470" textAnchor="middle" fontSize="14" fontWeight="bold" fill="#c2410c">Hormone-Sensitive</text>
      <text x="280" y="490" textAnchor="middle" fontSize="14" fontWeight="bold" fill="#c2410c">Lipase (HSL)</text>
      <text x="280" y="505" textAnchor="middle" fontSize="12" fill="#c2410c">Activation</text>
      
      {/* Arrow 3 */}
      <line x1="280" y1="410" x2="280" y2="450" stroke="#94a3b8" strokeWidth="2" markerEnd="url(#arrowhead)" />
      
      {/* 5. Cartilage Effect */}
      <rect x="400" y="180" width="120" height="60" rx="8" fill="#fef2f2" stroke="#f87171" strokeWidth="2" />
      <text x="460" y="205" textAnchor="middle" fontSize="14" fontWeight="bold" fill="#b91c1c">Potential</text>
      <text x="460" y="225" textAnchor="middle" fontSize="14" fontWeight="bold" fill="#b91c1c">Chondroprotective</text>
      
      {/* Arrow to cartilage */}
      <line x1="260" y1="160" x2="400" y2="200" stroke="#94a3b8" strokeWidth="2" strokeDasharray="5,5" markerEnd="url(#arrowhead)" />
      
      {/* 6. Fat Metabolism */}
      <ellipse cx="580" cy="420" rx="120" ry="80" fill="#fdf4ff" stroke="#d946ef" strokeWidth="2" />
      <text x="580" y="400" textAnchor="middle" fontSize="16" fontWeight="bold" fill="#a21caf">Lipolysis</text>
      <text x="580" y="425" textAnchor="middle" fontSize="13" fill="#a21caf">▲ Fat Breakdown</text>
      <text x="580" y="445" textAnchor="middle" fontSize="13" fill="#a21caf">▼ Fat Accumulation</text>
      
      {/* Arrow 4 */}
      <line x1="340" y1="480" x2="470" y2="430" stroke="#94a3b8" strokeWidth="2" markerEnd="url(#arrowhead)" />
      
      {/* 7. Glycerol Release */}
      <rect x="390" y="520" width="120" height="50" rx="8" fill="#f0fdfa" stroke="#2dd4bf" strokeWidth="2" />
      <text x="450" y="545" textAnchor="middle" fontSize="14" fontWeight="bold" fill="#0f766e">Glycerol Release</text>
      <text x="450" y="565" textAnchor="middle" fontSize="12" fill="#0f766e">from Adipocytes</text>
      
      {/* Arrow 5 */}
      <line x1="500" y1="480" x2="460" y2="520" stroke="#94a3b8" strokeWidth="2" markerEnd="url(#arrowhead)" />

      {/* 8. No IGF-1 */}
      <circle cx="650" cy="180" r="70" fill="#fafafa" stroke="#525252" strokeWidth="2" />
      <line x1="600" y1="160" x2="700" y2="200" stroke="#525252" strokeWidth="3" />
      <text x="650" y="140" textAnchor="middle" fontSize="14" fontWeight="bold" fill="#525252">No Significant</text>
      <text x="650" y="160" textAnchor="middle" fontSize="14" fontWeight="bold" fill="#525252">IGF-1 Production</text>
      <text x="650" y="180" textAnchor="middle" fontSize="13" fill="#525252">(Unlike Full GH)</text>
      
      {/* Key Takeaways Box */}
      <rect x="100" y="530" width="270" height="60" rx="8" fill="#ecfdf5" stroke="#10b981" strokeWidth="2" />
      <text x="120" y="555" fontSize="14" fontWeight="bold" fill="#047857">Key Distinction:</text>
      <text x="120" y="575" fontSize="12" fill="#047857">Lipolytic effects without GH's growth effects</text>
      
      {/* Arrow markers definition */}
      <defs>
        <marker 
          id="arrowhead" 
          markerWidth="10" 
          markerHeight="7" 
          refX="9" 
          refY="3.5" 
          orient="auto"
        >
          <polygon points="0 0, 10 3.5, 0 7" fill="#94a3b8" />
        </marker>
      </defs>
    </svg>
  );
};

export default AOD9604Diagram;